import appSelectors from 'App/duck/selectors'
import { RootState } from 'redux/types'

import ClubCardState from './types'

const getClubCardState = (state: RootState): ClubCardState => state.account.clubCard

const getCodeType = (state: RootState): string => getClubCardState(state).codeType
const getIsCodeTypeBarcode = (state: RootState): boolean => getCodeType(state) === 'ITF2OF5'
const getCodeImageUrl = (state: RootState): string => getClubCardState(state).codeImageUrl
const getCodeNumber = (state: RootState): string => getClubCardState(state).codeNumber

const getCurrentBalance = (state: RootState): number => getClubCardState(state).currentBalance
const getCurrentTier = (state: RootState): number => getClubCardState(state).currentTier
const getIsPlusMember = (state: RootState): boolean => getCurrentTier(state) > 0
const getCurrentTierCopy = (state: RootState): string => getClubCardState(state).currentTierCopy
const getNextTierCopy = (state: RootState): string => getClubCardState(state).nextTierCopy
const getMainMembershipCardCopy = (state: RootState): string =>
  getClubCardState(state).mainMembershipCardCopy
const getNextTierBalance = (state: RootState): number => getClubCardState(state).nextTierBalance
const getIsFailedToLoad = (state: RootState): boolean => getClubCardState(state).failedToLoad

const getShouldShowClubCard = (state: RootState): boolean =>
  getIsFailedToLoad(state) ||
  appSelectors.getIsUserLoading(state) ||
  appSelectors.getUserIsFullMember(state)

const getIsClubCardDrawerOpen = (state: RootState): boolean =>
  getClubCardState(state).isClubCardDrawerOpen

const getShouldRenderCounter = (state: RootState): boolean => !!getCurrentBalance(state)

export default {
  getIsCodeTypeBarcode,
  getCodeImageUrl,
  getCodeNumber,
  getCurrentBalance,
  getCurrentTier,
  getIsPlusMember,
  getCurrentTierCopy,
  getNextTierCopy,
  getMainMembershipCardCopy,
  getNextTierBalance,
  getShouldShowClubCard,
  getIsFailedToLoad,
  getIsClubCardDrawerOpen,
  getShouldRenderCounter,
  getClubCardState,
}
